import { Checkbox, FormControl, FormControlLabel } from "@material-ui/core";
import React from "react";

export const DaysCheckBox = ({ data, handleChange }) => {
  return (
    <FormControl
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
      }}
    >
      {data.map((day) => (
        <FormControlLabel
          key={day.value}
          control={
            <Checkbox
              checked={day.checked}
              onChange={handleChange}
              name={day.value}
              color="primary"
            />
          }
          label={day.value}
        />
      ))}
    </FormControl>
  );
};
